export enum Keyboard {
    SPACE = 32,
    ENTER = 13
}
